import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=ac362b74&scoped=true"
var script = {}
import style0 from "./PhoneIcon.vue?vue&type=style&index=0&id=ac362b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac362b74",
  null
  
)

export default component.exports